import { RawParams, StateService } from "@uirouter/angularjs";
import { UserProfile } from "../../../application/UserProfile";
import {
  MenuService,
  vsName as menuServiceName,
} from "../../../menu/provider/MenuService";
import { get } from "lodash";

interface UserServer {
  login(
    Username: any,
    Password: string,
    RememberMe: boolean,
    url?: string
  ): Promise<{}>;
}

interface ReturnInfo {
  name: string;
  params?: RawParams;
}

export class LoginPageController {
  static $inject = [
    "userServer",
    "$state",
    "userProfile",
    "applicationInfo",
    menuServiceName,
  ];

  static defaultReturnState = "findPage";
  /*bindings*/
  returnState: ReturnInfo = {
    name: LoginPageController.defaultReturnState,
  };

  RememberMe: boolean = false;
  Username: string = "";
  Password: string = "";
  authProviderCount: number = 0;
  Error: string = "";

  nonCredentialsAuthProviders: AuthProvider[];
  credentialAuthProvider: AuthProvider | undefined;
  authProviders: AuthProvider[];

  constructor(
    private readonly userServer: UserServer,
    private readonly $state: StateService,
    private readonly userProfile: UserProfile,
    private readonly applicationInfo: {
      hasAuthenticationProvider: (name: string) => boolean;
      appInfo: { AuthenticationProviders: AuthProvider[] };
    },
    private readonly menuService: MenuService
  ) {
    const authProviders = (this.authProviders =
      applicationInfo.appInfo.AuthenticationProviders);
    this.nonCredentialsAuthProviders = authProviders.filter((p) => p.GetOnly);
    this.authProviderCount = authProviders.length;
    this.credentialAuthProvider = authProviders.find((ap) => !ap.GetOnly);
  }

  hasAuthProviderOtherThanCredentials(): boolean {
    return this.nonCredentialsAuthProviders.length > 0;
  }

  hasAuthenticationProvider(name: string) {
    return this.applicationInfo.hasAuthenticationProvider(name);
  }

  Login() {
    this.userServer
      .login(
        this.Username,
        this.Password,
        this.RememberMe,
        `/api/auth/${this.credentialAuthProvider!.Name}`
      )
      .then((profile) => {
        this.userProfile.initialize(profile);
        this.menuService.setProfile(this.userProfile);

        const returnState: ReturnInfo = this.returnState ?? {
          name: LoginPageController.defaultReturnState,
        };

        return this.$state.go(returnState.name, returnState.params);
      })
      .catch((error) => {
        this.Password = "";
        const errorMessage =
          get(error, "data.ResponseStatus.Message") ??
          error ??
          "Unknown error message";
        this.Error = errorMessage;
      });
  }
}
